/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} First_CaptionInputs */

const en_first_caption = /** @type {(inputs: First_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First Caption:`)
};

const fr_first_caption = /** @type {(inputs: First_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Première légende :`)
};

const de_first_caption = /** @type {(inputs: First_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Bildunterschrift:`)
};

const it_first_caption = /** @type {(inputs: First_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima didascalia:`)
};

const ru_first_caption = /** @type {(inputs: First_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Первая подпись:`)
};

const es_first_caption = /** @type {(inputs: First_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primer subtítulo:`)
};

const zh_cn2_first_caption = /** @type {(inputs: First_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第一条标题：`)
};

const ja_first_caption = /** @type {(inputs: First_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初のキャプション:`)
};

const hi_first_caption = /** @type {(inputs: First_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहला कैप्शन:`)
};

const pt_pt2_first_caption = /** @type {(inputs: First_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeira legenda:`)
};

/**
* | output |
* | --- |
* | "First Caption:" |
*
* @param {First_CaptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const first_caption = /** @type {((inputs?: First_CaptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<First_CaptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_first_caption(inputs)
	if (locale === "de") return de_first_caption(inputs)
	if (locale === "it") return it_first_caption(inputs)
	if (locale === "ru") return ru_first_caption(inputs)
	if (locale === "es") return es_first_caption(inputs)
	if (locale === "zh-CN") return zh_cn2_first_caption(inputs)
	if (locale === "ja") return ja_first_caption(inputs)
	if (locale === "hi") return hi_first_caption(inputs)
	if (locale === "pt-PT") return pt_pt2_first_caption(inputs)
	return en_first_caption(inputs)
});